var map = {
	"./academic-cap-outline.svg": 30592,
	"./academic-cap-solid.svg": 63212,
	"./adjustments-outline.svg": 54077,
	"./adjustments-solid.svg": 80819,
	"./annotation-outline.svg": 22416,
	"./annotation-solid.svg": 8218,
	"./archive-outline.svg": 71193,
	"./archive-solid.svg": 85938,
	"./arrow-circle-down-outline.svg": 42086,
	"./arrow-circle-down-solid.svg": 67593,
	"./arrow-circle-left-outline.svg": 41514,
	"./arrow-circle-left-solid.svg": 33024,
	"./arrow-circle-right-outline.svg": 14968,
	"./arrow-circle-right-solid.svg": 70043,
	"./arrow-circle-up-outline.svg": 84296,
	"./arrow-circle-up-solid.svg": 88424,
	"./arrow-down-outline.svg": 72,
	"./arrow-down-solid.svg": 67077,
	"./arrow-down.svg": 64156,
	"./arrow-left-outline.svg": 25155,
	"./arrow-left-solid.svg": 35436,
	"./arrow-narrow-down-outline.svg": 70294,
	"./arrow-narrow-down-solid.svg": 89554,
	"./arrow-narrow-left-outline.svg": 60776,
	"./arrow-narrow-left-solid.svg": 28304,
	"./arrow-narrow-right-outline.svg": 50639,
	"./arrow-narrow-right-solid.svg": 38730,
	"./arrow-narrow-up-outline.svg": 84264,
	"./arrow-narrow-up-solid.svg": 46682,
	"./arrow-right-outline.svg": 27003,
	"./arrow-right-solid.svg": 95874,
	"./arrow-up-outline.svg": 20715,
	"./arrow-up-solid.svg": 15814,
	"./arrows-expand-outline.svg": 95453,
	"./arrows-expand-solid.svg": 43227,
	"./at-symbol-outline.svg": 77668,
	"./at-symbol-solid.svg": 13253,
	"./backspace-outline.svg": 2703,
	"./backspace-solid.svg": 44985,
	"./badge-check-outline.svg": 55807,
	"./badge-check-solid.svg": 78545,
	"./bag-category-outline.svg": 52042,
	"./ban-outline.svg": 61008,
	"./ban-solid.svg": 26155,
	"./beaker-outline.svg": 41320,
	"./beaker-solid.svg": 55606,
	"./bell-outline.svg": 75098,
	"./bell-solid.svg": 64643,
	"./book-open-outline.svg": 93866,
	"./book-open-solid.svg": 85353,
	"./bookmark-alt-outline.svg": 22454,
	"./bookmark-alt-solid.svg": 28527,
	"./bookmark-outline.svg": 74901,
	"./bookmark-solid.svg": 85078,
	"./briefcase-outline.svg": 93506,
	"./briefcase-solid.svg": 39331,
	"./cake-outline.svg": 66719,
	"./cake-solid.svg": 84649,
	"./calculator-outline.svg": 49051,
	"./calendar-outline.svg": 8751,
	"./calendar-solid.svg": 36278,
	"./camera-outline.svg": 37038,
	"./camera-solid.svg": 40276,
	"./cash-outline.svg": 24910,
	"./cash-solid.svg": 3336,
	"./chart-bar-outline.svg": 40806,
	"./chart-bar-solid.svg": 34145,
	"./chart-pie-outline.svg": 81572,
	"./chart-pie-solid.svg": 74976,
	"./chart-square-bar-outline.svg": 42057,
	"./chart-square-bar-solid.svg": 45995,
	"./chat-alt-2-outline.svg": 31398,
	"./chat-alt-2-solid.svg": 9265,
	"./chat-alt-outline.svg": 41199,
	"./chat-alt-solid.svg": 10542,
	"./chat-outline.svg": 6920,
	"./chat-solid.svg": 55250,
	"./check-circle-outline.svg": 7464,
	"./check-circle-solid.svg": 57118,
	"./check-mark-gray.svg": 87387,
	"./check-mark-white.svg": 19213,
	"./check-outline-white.svg": 16351,
	"./check-outline.svg": 1679,
	"./check-solid.svg": 14882,
	"./checkmark-square-active.svg": 69276,
	"./checkmark-square-none-white.svg": 75527,
	"./checkmark-square-none.svg": 87319,
	"./cheveron-down-outline.svg": 35598,
	"./cheveron-down-solid.svg": 2994,
	"./cheveron-left-outline.svg": 16795,
	"./cheveron-left-solid.svg": 88044,
	"./cheveron-right-solid.svg": 99294,
	"./cheveron-up-outline.svg": 30675,
	"./cheveron-up-solid.svg": 79739,
	"./chevron-double-down-outline.svg": 49486,
	"./chevron-double-down-solid.svg": 72510,
	"./chevron-double-left-outline.svg": 86820,
	"./chevron-double-left-solid.svg": 19504,
	"./chevron-double-right-outline.svg": 2103,
	"./chevron-double-right-solid.svg": 76866,
	"./chevron-double-up-outline.svg": 27601,
	"./chevron-double-up-solid.svg": 42642,
	"./chevron-right-outline.svg": 2363,
	"./chip-outline.svg": 63497,
	"./chip-solid.svg": 47247,
	"./clipboard-check-outline.svg": 73110,
	"./clipboard-check-solid.svg": 87340,
	"./clipboard-copy-outline.svg": 39767,
	"./clipboard-copy-solid.svg": 71374,
	"./clipboard-list-outline.svg": 89250,
	"./clipboard-list-solid.svg": 73439,
	"./clipboard-outline.svg": 4053,
	"./clock-outline.svg": 11601,
	"./clock-solid.svg": 76572,
	"./cloud-download-outline.svg": 47236,
	"./cloud-download-solid.svg": 21369,
	"./cloud-outline.svg": 33738,
	"./cloud-solid.svg": 10609,
	"./cloud-upload-outline.svg": 29169,
	"./cloud-upload-solid.svg": 63460,
	"./code-outline.svg": 54801,
	"./code-solid.svg": 75889,
	"./cog-outline.svg": 26265,
	"./cog-solid.svg": 40927,
	"./collection-outline.svg": 57081,
	"./collection-solid.svg": 79264,
	"./color-swatch-outline.svg": 71765,
	"./color-swatch-solid.svg": 98983,
	"./credit-card-outline.svg": 64598,
	"./credit-card-solid.svg": 21282,
	"./cube-outline.svg": 60054,
	"./cube-solid.svg": 51794,
	"./cube-transparent-outline.svg": 75861,
	"./cube-transparent-solid.svg": 91611,
	"./currency-bangladeshi-outline.svg": 80280,
	"./currency-bangladeshi-solid.svg": 16771,
	"./currency-dollar-outline.svg": 75771,
	"./currency-dollar-solid.svg": 48685,
	"./currency-euro-outline.svg": 1052,
	"./currency-euro-solid.svg": 95498,
	"./currency-pound-outline.svg": 71437,
	"./currency-pound-solid.svg": 50601,
	"./currency-rupee-outline.svg": 20790,
	"./currency-rupee-solid.svg": 38573,
	"./currency-yen-outline.svg": 34509,
	"./currency-yen-solid.svg": 74302,
	"./cursor-click-outline.svg": 95368,
	"./cursor-click-solid.svg": 41353,
	"./database-outline.svg": 88086,
	"./database-solid.svg": 30870,
	"./desktop-computer-outline.svg": 36786,
	"./desktop-computer-solid.svg": 90480,
	"./device-mobile-outline.svg": 29258,
	"./device-mobile-solid.svg": 70406,
	"./device-tablet-outline.svg": 65146,
	"./document-add-outline.svg": 59135,
	"./document-add-solid.svg": 57811,
	"./document-download-outline.svg": 80877,
	"./document-download-solid.svg": 12888,
	"./document-duplicate-outline.svg": 92184,
	"./document-duplicate-solid.svg": 74834,
	"./document-outline.svg": 69112,
	"./document-remove-outline.svg": 66768,
	"./document-remove-solid.svg": 95426,
	"./document-report-outline.svg": 49228,
	"./document-report-solid.svg": 11,
	"./document-search-outline.svg": 28233,
	"./document-search-solid.svg": 58123,
	"./document-solid.svg": 34402,
	"./document-text-outline.svg": 33839,
	"./document-text-solid.svg": 88960,
	"./dots-circle-horizontal-outline.svg": 2203,
	"./dots-circle-horizontal-solid.svg": 80033,
	"./dots-horizontal-outline.svg": 963,
	"./dots-horizontal-solid.svg": 61496,
	"./dots-vertical-outline.svg": 57237,
	"./dots-vertical-solid.svg": 66688,
	"./download-outline.svg": 34643,
	"./download-solid-1.svg": 25738,
	"./download-solid.svg": 68760,
	"./duplicate-outline.svg": 94158,
	"./duplicate-solid.svg": 84411,
	"./ehphuong.svg": 84221,
	"./emoji-happy-outline.svg": 29458,
	"./emoji-happy-solid.svg": 31359,
	"./emoji-sad-outline.svg": 68972,
	"./emoji-sad-solid.svg": 17975,
	"./exclamation-circle-outline.svg": 63003,
	"./exclamation-circle-solid.svg": 10725,
	"./exclamation-outline.svg": 62740,
	"./exclamation-solid.svg": 81752,
	"./external-link-outline.svg": 25228,
	"./external-link-solid.svg": 79123,
	"./eye-off-outline.svg": 53405,
	"./eye-off-solid.svg": 34310,
	"./eye-outline.svg": 76433,
	"./eye-solid.svg": 74526,
	"./fast-forward-outline.svg": 81828,
	"./fast-forward-solid.svg": 14723,
	"./film-outline.svg": 72285,
	"./film-solid.svg": 79364,
	"./filter-outline.svg": 55416,
	"./filter-solid.svg": 27993,
	"./finger-print-outline.svg": 3007,
	"./finger-print-solid.svg": 29337,
	"./fire-outline.svg": 54433,
	"./fire-solid.svg": 77735,
	"./flag-outline.svg": 5594,
	"./flag-solid.svg": 91384,
	"./folder-add-outline.svg": 68934,
	"./folder-add-solid.svg": 91267,
	"./folder-download-outline.svg": 45534,
	"./folder-download-solid.svg": 69373,
	"./folder-open-outline.svg": 9603,
	"./folder-open-solid.svg": 97223,
	"./folder-outline.svg": 79492,
	"./folder-remove-outline.svg": 88834,
	"./folder-remove-solid.svg": 30165,
	"./folder-solid.svg": 68648,
	"./gift-outline.svg": 9343,
	"./gift-solid.svg": 81606,
	"./globe-alt-outline.svg": 67881,
	"./globe-alt-solid.svg": 63388,
	"./globe-outline.svg": 12010,
	"./globe-solid.svg": 93123,
	"./hand-outline.svg": 87757,
	"./hand-solid.svg": 70792,
	"./hashtag-outline.svg": 66329,
	"./hashtag-solid.svg": 19056,
	"./heart-outline.svg": 85330,
	"./heart-solid.svg": 54146,
	"./home-outline.svg": 11137,
	"./home-solid.svg": 24970,
	"./icon-currency-dollar-solid.svg": 80437,
	"./icon-user-remove-outline.svg": 65766,
	"./identification-outline.svg": 88757,
	"./identification-solid.svg": 68124,
	"./inbox-in-outline.svg": 32677,
	"./inbox-in-solid.svg": 66722,
	"./inbox-outline.svg": 76392,
	"./inbox-solid.svg": 66911,
	"./information-circle-outline.svg": 66515,
	"./information-circle-solid.svg": 22203,
	"./key-outline.svg": 97010,
	"./key-solid.svg": 81926,
	"./library-outline.svg": 67892,
	"./light-bulb-outline.svg": 95212,
	"./light-bulb-solid.svg": 79690,
	"./lightning-bolt-outline.svg": 68015,
	"./lightning-bolt-solid.svg": 41851,
	"./link-outline.svg": 84641,
	"./link-solid.svg": 42643,
	"./location-marker-outline.svg": 65759,
	"./location-marker-solid.svg": 48702,
	"./lock-closed-outline.svg": 37405,
	"./lock-closed-solid.svg": 66024,
	"./lock-open-outline.svg": 45159,
	"./lock-open-solid.svg": 22809,
	"./logout-outline-1.svg": 57684,
	"./logout-outline.svg": 63840,
	"./logout-solid-1.svg": 32185,
	"./logout-solid.svg": 79433,
	"./mail-open-outline.svg": 2329,
	"./mail-open-solid.svg": 60082,
	"./mail-outline.svg": 52173,
	"./mail-solid-1.svg": 49826,
	"./mail-solid.svg": 6869,
	"./map-outline.svg": 87617,
	"./map-solid.svg": 79080,
	"./md-library-solid.svg": 39077,
	"./menu-alt-1-outline.svg": 71380,
	"./menu-alt-1-solid.svg": 25029,
	"./menu-alt-2-outline.svg": 98309,
	"./menu-alt-2-solid.svg": 27160,
	"./menu-alt-3-outline.svg": 81050,
	"./menu-alt-3-solid.svg": 92723,
	"./menu-alt-4-outline.svg": 78588,
	"./menu-alt-4-solid.svg": 47119,
	"./menu-outline.svg": 14703,
	"./menu-solid.svg": 77089,
	"./microphone-outline.svg": 51319,
	"./microphone-solid.svg": 84228,
	"./minimal-summary.svg": 20756,
	"./minus-circle-outline.svg": 62068,
	"./minus-circle-solid.svg": 70081,
	"./minus-outline-1.svg": 32740,
	"./minus-outline.svg": 75840,
	"./minus-solid-1.svg": 4183,
	"./minus-solid.svg": 30517,
	"./moon-outline.svg": 11452,
	"./moon-solid.svg": 18595,
	"./music-note-outline.svg": 56398,
	"./music-note-solid.svg": 94244,
	"./newspaper-outline.svg": 9196,
	"./newspaper-solid.svg": 52361,
	"./office-building-outline.svg": 11751,
	"./office-building-solid.svg": 64623,
	"./paper-airplane-outline.svg": 83735,
	"./paper-airplane-solid.svg": 99649,
	"./paper-clip-outline.svg": 31281,
	"./paper-clip-solid.svg": 59902,
	"./pause-outline.svg": 33906,
	"./pause-solid.svg": 76582,
	"./pencil-alt-outline.svg": 28913,
	"./pencil-alt-solid.svg": 54638,
	"./pencil-outline.svg": 10223,
	"./pencil-solid.svg": 67753,
	"./phone-incoming-outline.svg": 10225,
	"./phone-incoming-solid.svg": 25095,
	"./phone-missed-call-outline.svg": 60895,
	"./phone-missed-call-solid.svg": 62082,
	"./phone-outgoing-outline.svg": 39718,
	"./phone-outgoing-solid.svg": 40837,
	"./phone-outline.svg": 53113,
	"./phone-solid.svg": 43062,
	"./photograph-outline.svg": 40628,
	"./photograph-solid.svg": 3104,
	"./play-outline-1.svg": 14094,
	"./play-outline.svg": 3813,
	"./play-solid.svg": 95328,
	"./plus-circle-outline.svg": 28330,
	"./plus-circle-solid.svg": 32394,
	"./plus-outline-1.svg": 87146,
	"./plus-outline.svg": 11922,
	"./plus-solid-1.svg": 67379,
	"./plus-solid.svg": 68264,
	"./presentation-chart-bar-outline.svg": 60995,
	"./presentation-chart-bar-solid.svg": 61336,
	"./presentation-chart-line-outline.svg": 35934,
	"./presentation-chart-line-solid.svg": 28237,
	"./printer-outline.svg": 68285,
	"./printer-solid.svg": 64042,
	"./puzzle-outline.svg": 76384,
	"./puzzle-solid.svg": 1148,
	"./qrcode-outline.svg": 73799,
	"./qrcode-solid.svg": 77086,
	"./question-mark-circle-outline.svg": 82117,
	"./question-mark-circle-solid.svg": 92516,
	"./receipt-refund-outline.svg": 21856,
	"./receipt-refund-solid.svg": 27847,
	"./receipt-tax-outline.svg": 49426,
	"./receipt-tax-solid.svg": 16746,
	"./refresh-outline.svg": 530,
	"./refresh-solid.svg": 22113,
	"./reply-outline.svg": 14325,
	"./reply-solid.svg": 40734,
	"./rewind-outline.svg": 34093,
	"./rewind-solid.svg": 43741,
	"./rss-outline.svg": 40784,
	"./rss-solid.svg": 21399,
	"./save-as-outline.svg": 4201,
	"./save-as-solid.svg": 49414,
	"./save-outline.svg": 3117,
	"./save-solid.svg": 29786,
	"./scale-outline.svg": 58521,
	"./scale-solid.svg": 71465,
	"./scissors-outline.svg": 41896,
	"./scissors-solid.svg": 70078,
	"./search-circle-outline.svg": 20357,
	"./search-circle-solid.svg": 51608,
	"./search-outline.svg": 63193,
	"./search-solid.svg": 60220,
	"./selector-outline.svg": 78483,
	"./selector-solid.svg": 7797,
	"./server-outline.svg": 38830,
	"./server-solid.svg": 51171,
	"./share-outline.svg": 53160,
	"./share-solid.svg": 83592,
	"./shield-check-outline.svg": 58660,
	"./shield-check-solid.svg": 41842,
	"./shield-exclamation-outline.svg": 78335,
	"./shield-exclamation-solid.svg": 66108,
	"./shoes-category-outline.svg": 11823,
	"./shopping-bag-outline.svg": 29782,
	"./shopping-bag-solid.svg": 32744,
	"./shopping-cart-outline.svg": 34838,
	"./sm-view-grid-add-outline.svg": 86348,
	"./sort-ascending-outline.svg": 852,
	"./sort-ascending-solid.svg": 806,
	"./sort-descending-outline.svg": 14193,
	"./sort-descending-solid.svg": 45894,
	"./sparkles-outline.svg": 23945,
	"./sparkles-solid.svg": 74843,
	"./speakerphone-outline.svg": 33402,
	"./speakerphone-solid.svg": 40,
	"./star-outline.svg": 76001,
	"./star-solid.svg": 95374,
	"./status-offline-outline.svg": 43745,
	"./status-offline-solid.svg": 22132,
	"./status-online-outline.svg": 54975,
	"./status-online-solid.svg": 25073,
	"./stop-outline.svg": 52311,
	"./stop-solid.svg": 27538,
	"./subtitles.svg": 24247,
	"./summary.svg": 55608,
	"./sun-outline.svg": 66766,
	"./sun-solid.svg": 88463,
	"./support-outline.svg": 65256,
	"./support-solid.svg": 98678,
	"./switch-horizontal-outline.svg": 13584,
	"./switch-horizontal-solid.svg": 40392,
	"./switch-vertical-outline.svg": 16786,
	"./switch-vertical-solid.svg": 4897,
	"./table-outline.svg": 22939,
	"./table-solid-1.svg": 85424,
	"./table-solid.svg": 60113,
	"./tag-outline.svg": 11178,
	"./tag-solid.svg": 2973,
	"./template-outline.svg": 43774,
	"./template-solid.svg": 14676,
	"./terminal-outline.svg": 35730,
	"./terminal-solid.svg": 27917,
	"./thumb-down-outline.svg": 51107,
	"./thumb-down-solid.svg": 83292,
	"./thumb-up-outline.svg": 84344,
	"./thumb-up-solid.svg": 5293,
	"./ticket-outline.svg": 45418,
	"./ticket-solid.svg": 4616,
	"./translate-outline.svg": 19891,
	"./translate-solid.svg": 59787,
	"./trash-outline.svg": 34208,
	"./trash-solid.svg": 96126,
	"./trending-down-outline.svg": 13279,
	"./trending-down-solid.svg": 30143,
	"./trending-up-outline.svg": 19076,
	"./trending-up-solid.svg": 92462,
	"./truck-outline.svg": 18512,
	"./truck-solid.svg": 89892,
	"./upload-outline.svg": 97439,
	"./upload-solid.svg": 78289,
	"./user-add-outline.svg": 97862,
	"./user-add-solid.svg": 50685,
	"./user-circle-outline.svg": 70959,
	"./user-circle-solid.svg": 26497,
	"./user-group-outline.svg": 72757,
	"./user-group-solid.svg": 28980,
	"./user-outline.svg": 86006,
	"./user-remove-solid.svg": 53475,
	"./user-solid.svg": 81718,
	"./users-outline.svg": 39661,
	"./users-solid.svg": 7366,
	"./variable-outline.svg": 26169,
	"./variable-solid.svg": 62170,
	"./video-camera-outline.svg": 26339,
	"./video-camera-solid.svg": 79344,
	"./view-boards-outline.svg": 46083,
	"./view-boards-solid.svg": 18698,
	"./view-grid-add-solid.svg": 86270,
	"./view-grid-outline.svg": 20035,
	"./view-grid-solid.svg": 9145,
	"./view-list-outline.svg": 57319,
	"./view-list-solid.svg": 73504,
	"./volume-off-outline.svg": 66982,
	"./volume-off-solid.svg": 77363,
	"./volume-up-outline.svg": 50730,
	"./volume-up-solid.svg": 11577,
	"./wifi-outline.svg": 96503,
	"./wifi-solid.svg": 99039,
	"./x-circle-outline.svg": 77768,
	"./x-circle-solid.svg": 91814,
	"./x-outline.svg": 39548,
	"./x-solid-white.svg": 84759,
	"./x-solid.svg": 78019,
	"./zoom-in-outline.svg": 10702,
	"./zoom-in-solid.svg": 80810,
	"./zoom-out-outline.svg": 62224,
	"./zoom-out-solid.svg": 21791,
	"gstyles/styleguide/icons/svgs/academic-cap-outline.svg": 30592,
	"gstyles/styleguide/icons/svgs/academic-cap-solid.svg": 63212,
	"gstyles/styleguide/icons/svgs/adjustments-outline.svg": 54077,
	"gstyles/styleguide/icons/svgs/adjustments-solid.svg": 80819,
	"gstyles/styleguide/icons/svgs/annotation-outline.svg": 22416,
	"gstyles/styleguide/icons/svgs/annotation-solid.svg": 8218,
	"gstyles/styleguide/icons/svgs/archive-outline.svg": 71193,
	"gstyles/styleguide/icons/svgs/archive-solid.svg": 85938,
	"gstyles/styleguide/icons/svgs/arrow-circle-down-outline.svg": 42086,
	"gstyles/styleguide/icons/svgs/arrow-circle-down-solid.svg": 67593,
	"gstyles/styleguide/icons/svgs/arrow-circle-left-outline.svg": 41514,
	"gstyles/styleguide/icons/svgs/arrow-circle-left-solid.svg": 33024,
	"gstyles/styleguide/icons/svgs/arrow-circle-right-outline.svg": 14968,
	"gstyles/styleguide/icons/svgs/arrow-circle-right-solid.svg": 70043,
	"gstyles/styleguide/icons/svgs/arrow-circle-up-outline.svg": 84296,
	"gstyles/styleguide/icons/svgs/arrow-circle-up-solid.svg": 88424,
	"gstyles/styleguide/icons/svgs/arrow-down-outline.svg": 72,
	"gstyles/styleguide/icons/svgs/arrow-down-solid.svg": 67077,
	"gstyles/styleguide/icons/svgs/arrow-down.svg": 64156,
	"gstyles/styleguide/icons/svgs/arrow-left-outline.svg": 25155,
	"gstyles/styleguide/icons/svgs/arrow-left-solid.svg": 35436,
	"gstyles/styleguide/icons/svgs/arrow-narrow-down-outline.svg": 70294,
	"gstyles/styleguide/icons/svgs/arrow-narrow-down-solid.svg": 89554,
	"gstyles/styleguide/icons/svgs/arrow-narrow-left-outline.svg": 60776,
	"gstyles/styleguide/icons/svgs/arrow-narrow-left-solid.svg": 28304,
	"gstyles/styleguide/icons/svgs/arrow-narrow-right-outline.svg": 50639,
	"gstyles/styleguide/icons/svgs/arrow-narrow-right-solid.svg": 38730,
	"gstyles/styleguide/icons/svgs/arrow-narrow-up-outline.svg": 84264,
	"gstyles/styleguide/icons/svgs/arrow-narrow-up-solid.svg": 46682,
	"gstyles/styleguide/icons/svgs/arrow-right-outline.svg": 27003,
	"gstyles/styleguide/icons/svgs/arrow-right-solid.svg": 95874,
	"gstyles/styleguide/icons/svgs/arrow-up-outline.svg": 20715,
	"gstyles/styleguide/icons/svgs/arrow-up-solid.svg": 15814,
	"gstyles/styleguide/icons/svgs/arrows-expand-outline.svg": 95453,
	"gstyles/styleguide/icons/svgs/arrows-expand-solid.svg": 43227,
	"gstyles/styleguide/icons/svgs/at-symbol-outline.svg": 77668,
	"gstyles/styleguide/icons/svgs/at-symbol-solid.svg": 13253,
	"gstyles/styleguide/icons/svgs/backspace-outline.svg": 2703,
	"gstyles/styleguide/icons/svgs/backspace-solid.svg": 44985,
	"gstyles/styleguide/icons/svgs/badge-check-outline.svg": 55807,
	"gstyles/styleguide/icons/svgs/badge-check-solid.svg": 78545,
	"gstyles/styleguide/icons/svgs/bag-category-outline.svg": 52042,
	"gstyles/styleguide/icons/svgs/ban-outline.svg": 61008,
	"gstyles/styleguide/icons/svgs/ban-solid.svg": 26155,
	"gstyles/styleguide/icons/svgs/beaker-outline.svg": 41320,
	"gstyles/styleguide/icons/svgs/beaker-solid.svg": 55606,
	"gstyles/styleguide/icons/svgs/bell-outline.svg": 75098,
	"gstyles/styleguide/icons/svgs/bell-solid.svg": 64643,
	"gstyles/styleguide/icons/svgs/book-open-outline.svg": 93866,
	"gstyles/styleguide/icons/svgs/book-open-solid.svg": 85353,
	"gstyles/styleguide/icons/svgs/bookmark-alt-outline.svg": 22454,
	"gstyles/styleguide/icons/svgs/bookmark-alt-solid.svg": 28527,
	"gstyles/styleguide/icons/svgs/bookmark-outline.svg": 74901,
	"gstyles/styleguide/icons/svgs/bookmark-solid.svg": 85078,
	"gstyles/styleguide/icons/svgs/briefcase-outline.svg": 93506,
	"gstyles/styleguide/icons/svgs/briefcase-solid.svg": 39331,
	"gstyles/styleguide/icons/svgs/cake-outline.svg": 66719,
	"gstyles/styleguide/icons/svgs/cake-solid.svg": 84649,
	"gstyles/styleguide/icons/svgs/calculator-outline.svg": 49051,
	"gstyles/styleguide/icons/svgs/calendar-outline.svg": 8751,
	"gstyles/styleguide/icons/svgs/calendar-solid.svg": 36278,
	"gstyles/styleguide/icons/svgs/camera-outline.svg": 37038,
	"gstyles/styleguide/icons/svgs/camera-solid.svg": 40276,
	"gstyles/styleguide/icons/svgs/cash-outline.svg": 24910,
	"gstyles/styleguide/icons/svgs/cash-solid.svg": 3336,
	"gstyles/styleguide/icons/svgs/chart-bar-outline.svg": 40806,
	"gstyles/styleguide/icons/svgs/chart-bar-solid.svg": 34145,
	"gstyles/styleguide/icons/svgs/chart-pie-outline.svg": 81572,
	"gstyles/styleguide/icons/svgs/chart-pie-solid.svg": 74976,
	"gstyles/styleguide/icons/svgs/chart-square-bar-outline.svg": 42057,
	"gstyles/styleguide/icons/svgs/chart-square-bar-solid.svg": 45995,
	"gstyles/styleguide/icons/svgs/chat-alt-2-outline.svg": 31398,
	"gstyles/styleguide/icons/svgs/chat-alt-2-solid.svg": 9265,
	"gstyles/styleguide/icons/svgs/chat-alt-outline.svg": 41199,
	"gstyles/styleguide/icons/svgs/chat-alt-solid.svg": 10542,
	"gstyles/styleguide/icons/svgs/chat-outline.svg": 6920,
	"gstyles/styleguide/icons/svgs/chat-solid.svg": 55250,
	"gstyles/styleguide/icons/svgs/check-circle-outline.svg": 7464,
	"gstyles/styleguide/icons/svgs/check-circle-solid.svg": 57118,
	"gstyles/styleguide/icons/svgs/check-mark-gray.svg": 87387,
	"gstyles/styleguide/icons/svgs/check-mark-white.svg": 19213,
	"gstyles/styleguide/icons/svgs/check-outline-white.svg": 16351,
	"gstyles/styleguide/icons/svgs/check-outline.svg": 1679,
	"gstyles/styleguide/icons/svgs/check-solid.svg": 14882,
	"gstyles/styleguide/icons/svgs/checkmark-square-active.svg": 69276,
	"gstyles/styleguide/icons/svgs/checkmark-square-none-white.svg": 75527,
	"gstyles/styleguide/icons/svgs/checkmark-square-none.svg": 87319,
	"gstyles/styleguide/icons/svgs/cheveron-down-outline.svg": 35598,
	"gstyles/styleguide/icons/svgs/cheveron-down-solid.svg": 2994,
	"gstyles/styleguide/icons/svgs/cheveron-left-outline.svg": 16795,
	"gstyles/styleguide/icons/svgs/cheveron-left-solid.svg": 88044,
	"gstyles/styleguide/icons/svgs/cheveron-right-solid.svg": 99294,
	"gstyles/styleguide/icons/svgs/cheveron-up-outline.svg": 30675,
	"gstyles/styleguide/icons/svgs/cheveron-up-solid.svg": 79739,
	"gstyles/styleguide/icons/svgs/chevron-double-down-outline.svg": 49486,
	"gstyles/styleguide/icons/svgs/chevron-double-down-solid.svg": 72510,
	"gstyles/styleguide/icons/svgs/chevron-double-left-outline.svg": 86820,
	"gstyles/styleguide/icons/svgs/chevron-double-left-solid.svg": 19504,
	"gstyles/styleguide/icons/svgs/chevron-double-right-outline.svg": 2103,
	"gstyles/styleguide/icons/svgs/chevron-double-right-solid.svg": 76866,
	"gstyles/styleguide/icons/svgs/chevron-double-up-outline.svg": 27601,
	"gstyles/styleguide/icons/svgs/chevron-double-up-solid.svg": 42642,
	"gstyles/styleguide/icons/svgs/chevron-right-outline.svg": 2363,
	"gstyles/styleguide/icons/svgs/chip-outline.svg": 63497,
	"gstyles/styleguide/icons/svgs/chip-solid.svg": 47247,
	"gstyles/styleguide/icons/svgs/clipboard-check-outline.svg": 73110,
	"gstyles/styleguide/icons/svgs/clipboard-check-solid.svg": 87340,
	"gstyles/styleguide/icons/svgs/clipboard-copy-outline.svg": 39767,
	"gstyles/styleguide/icons/svgs/clipboard-copy-solid.svg": 71374,
	"gstyles/styleguide/icons/svgs/clipboard-list-outline.svg": 89250,
	"gstyles/styleguide/icons/svgs/clipboard-list-solid.svg": 73439,
	"gstyles/styleguide/icons/svgs/clipboard-outline.svg": 4053,
	"gstyles/styleguide/icons/svgs/clock-outline.svg": 11601,
	"gstyles/styleguide/icons/svgs/clock-solid.svg": 76572,
	"gstyles/styleguide/icons/svgs/cloud-download-outline.svg": 47236,
	"gstyles/styleguide/icons/svgs/cloud-download-solid.svg": 21369,
	"gstyles/styleguide/icons/svgs/cloud-outline.svg": 33738,
	"gstyles/styleguide/icons/svgs/cloud-solid.svg": 10609,
	"gstyles/styleguide/icons/svgs/cloud-upload-outline.svg": 29169,
	"gstyles/styleguide/icons/svgs/cloud-upload-solid.svg": 63460,
	"gstyles/styleguide/icons/svgs/code-outline.svg": 54801,
	"gstyles/styleguide/icons/svgs/code-solid.svg": 75889,
	"gstyles/styleguide/icons/svgs/cog-outline.svg": 26265,
	"gstyles/styleguide/icons/svgs/cog-solid.svg": 40927,
	"gstyles/styleguide/icons/svgs/collection-outline.svg": 57081,
	"gstyles/styleguide/icons/svgs/collection-solid.svg": 79264,
	"gstyles/styleguide/icons/svgs/color-swatch-outline.svg": 71765,
	"gstyles/styleguide/icons/svgs/color-swatch-solid.svg": 98983,
	"gstyles/styleguide/icons/svgs/credit-card-outline.svg": 64598,
	"gstyles/styleguide/icons/svgs/credit-card-solid.svg": 21282,
	"gstyles/styleguide/icons/svgs/cube-outline.svg": 60054,
	"gstyles/styleguide/icons/svgs/cube-solid.svg": 51794,
	"gstyles/styleguide/icons/svgs/cube-transparent-outline.svg": 75861,
	"gstyles/styleguide/icons/svgs/cube-transparent-solid.svg": 91611,
	"gstyles/styleguide/icons/svgs/currency-bangladeshi-outline.svg": 80280,
	"gstyles/styleguide/icons/svgs/currency-bangladeshi-solid.svg": 16771,
	"gstyles/styleguide/icons/svgs/currency-dollar-outline.svg": 75771,
	"gstyles/styleguide/icons/svgs/currency-dollar-solid.svg": 48685,
	"gstyles/styleguide/icons/svgs/currency-euro-outline.svg": 1052,
	"gstyles/styleguide/icons/svgs/currency-euro-solid.svg": 95498,
	"gstyles/styleguide/icons/svgs/currency-pound-outline.svg": 71437,
	"gstyles/styleguide/icons/svgs/currency-pound-solid.svg": 50601,
	"gstyles/styleguide/icons/svgs/currency-rupee-outline.svg": 20790,
	"gstyles/styleguide/icons/svgs/currency-rupee-solid.svg": 38573,
	"gstyles/styleguide/icons/svgs/currency-yen-outline.svg": 34509,
	"gstyles/styleguide/icons/svgs/currency-yen-solid.svg": 74302,
	"gstyles/styleguide/icons/svgs/cursor-click-outline.svg": 95368,
	"gstyles/styleguide/icons/svgs/cursor-click-solid.svg": 41353,
	"gstyles/styleguide/icons/svgs/database-outline.svg": 88086,
	"gstyles/styleguide/icons/svgs/database-solid.svg": 30870,
	"gstyles/styleguide/icons/svgs/desktop-computer-outline.svg": 36786,
	"gstyles/styleguide/icons/svgs/desktop-computer-solid.svg": 90480,
	"gstyles/styleguide/icons/svgs/device-mobile-outline.svg": 29258,
	"gstyles/styleguide/icons/svgs/device-mobile-solid.svg": 70406,
	"gstyles/styleguide/icons/svgs/device-tablet-outline.svg": 65146,
	"gstyles/styleguide/icons/svgs/document-add-outline.svg": 59135,
	"gstyles/styleguide/icons/svgs/document-add-solid.svg": 57811,
	"gstyles/styleguide/icons/svgs/document-download-outline.svg": 80877,
	"gstyles/styleguide/icons/svgs/document-download-solid.svg": 12888,
	"gstyles/styleguide/icons/svgs/document-duplicate-outline.svg": 92184,
	"gstyles/styleguide/icons/svgs/document-duplicate-solid.svg": 74834,
	"gstyles/styleguide/icons/svgs/document-outline.svg": 69112,
	"gstyles/styleguide/icons/svgs/document-remove-outline.svg": 66768,
	"gstyles/styleguide/icons/svgs/document-remove-solid.svg": 95426,
	"gstyles/styleguide/icons/svgs/document-report-outline.svg": 49228,
	"gstyles/styleguide/icons/svgs/document-report-solid.svg": 11,
	"gstyles/styleguide/icons/svgs/document-search-outline.svg": 28233,
	"gstyles/styleguide/icons/svgs/document-search-solid.svg": 58123,
	"gstyles/styleguide/icons/svgs/document-solid.svg": 34402,
	"gstyles/styleguide/icons/svgs/document-text-outline.svg": 33839,
	"gstyles/styleguide/icons/svgs/document-text-solid.svg": 88960,
	"gstyles/styleguide/icons/svgs/dots-circle-horizontal-outline.svg": 2203,
	"gstyles/styleguide/icons/svgs/dots-circle-horizontal-solid.svg": 80033,
	"gstyles/styleguide/icons/svgs/dots-horizontal-outline.svg": 963,
	"gstyles/styleguide/icons/svgs/dots-horizontal-solid.svg": 61496,
	"gstyles/styleguide/icons/svgs/dots-vertical-outline.svg": 57237,
	"gstyles/styleguide/icons/svgs/dots-vertical-solid.svg": 66688,
	"gstyles/styleguide/icons/svgs/download-outline.svg": 34643,
	"gstyles/styleguide/icons/svgs/download-solid-1.svg": 25738,
	"gstyles/styleguide/icons/svgs/download-solid.svg": 68760,
	"gstyles/styleguide/icons/svgs/duplicate-outline.svg": 94158,
	"gstyles/styleguide/icons/svgs/duplicate-solid.svg": 84411,
	"gstyles/styleguide/icons/svgs/ehphuong.svg": 84221,
	"gstyles/styleguide/icons/svgs/emoji-happy-outline.svg": 29458,
	"gstyles/styleguide/icons/svgs/emoji-happy-solid.svg": 31359,
	"gstyles/styleguide/icons/svgs/emoji-sad-outline.svg": 68972,
	"gstyles/styleguide/icons/svgs/emoji-sad-solid.svg": 17975,
	"gstyles/styleguide/icons/svgs/exclamation-circle-outline.svg": 63003,
	"gstyles/styleguide/icons/svgs/exclamation-circle-solid.svg": 10725,
	"gstyles/styleguide/icons/svgs/exclamation-outline.svg": 62740,
	"gstyles/styleguide/icons/svgs/exclamation-solid.svg": 81752,
	"gstyles/styleguide/icons/svgs/external-link-outline.svg": 25228,
	"gstyles/styleguide/icons/svgs/external-link-solid.svg": 79123,
	"gstyles/styleguide/icons/svgs/eye-off-outline.svg": 53405,
	"gstyles/styleguide/icons/svgs/eye-off-solid.svg": 34310,
	"gstyles/styleguide/icons/svgs/eye-outline.svg": 76433,
	"gstyles/styleguide/icons/svgs/eye-solid.svg": 74526,
	"gstyles/styleguide/icons/svgs/fast-forward-outline.svg": 81828,
	"gstyles/styleguide/icons/svgs/fast-forward-solid.svg": 14723,
	"gstyles/styleguide/icons/svgs/film-outline.svg": 72285,
	"gstyles/styleguide/icons/svgs/film-solid.svg": 79364,
	"gstyles/styleguide/icons/svgs/filter-outline.svg": 55416,
	"gstyles/styleguide/icons/svgs/filter-solid.svg": 27993,
	"gstyles/styleguide/icons/svgs/finger-print-outline.svg": 3007,
	"gstyles/styleguide/icons/svgs/finger-print-solid.svg": 29337,
	"gstyles/styleguide/icons/svgs/fire-outline.svg": 54433,
	"gstyles/styleguide/icons/svgs/fire-solid.svg": 77735,
	"gstyles/styleguide/icons/svgs/flag-outline.svg": 5594,
	"gstyles/styleguide/icons/svgs/flag-solid.svg": 91384,
	"gstyles/styleguide/icons/svgs/folder-add-outline.svg": 68934,
	"gstyles/styleguide/icons/svgs/folder-add-solid.svg": 91267,
	"gstyles/styleguide/icons/svgs/folder-download-outline.svg": 45534,
	"gstyles/styleguide/icons/svgs/folder-download-solid.svg": 69373,
	"gstyles/styleguide/icons/svgs/folder-open-outline.svg": 9603,
	"gstyles/styleguide/icons/svgs/folder-open-solid.svg": 97223,
	"gstyles/styleguide/icons/svgs/folder-outline.svg": 79492,
	"gstyles/styleguide/icons/svgs/folder-remove-outline.svg": 88834,
	"gstyles/styleguide/icons/svgs/folder-remove-solid.svg": 30165,
	"gstyles/styleguide/icons/svgs/folder-solid.svg": 68648,
	"gstyles/styleguide/icons/svgs/gift-outline.svg": 9343,
	"gstyles/styleguide/icons/svgs/gift-solid.svg": 81606,
	"gstyles/styleguide/icons/svgs/globe-alt-outline.svg": 67881,
	"gstyles/styleguide/icons/svgs/globe-alt-solid.svg": 63388,
	"gstyles/styleguide/icons/svgs/globe-outline.svg": 12010,
	"gstyles/styleguide/icons/svgs/globe-solid.svg": 93123,
	"gstyles/styleguide/icons/svgs/hand-outline.svg": 87757,
	"gstyles/styleguide/icons/svgs/hand-solid.svg": 70792,
	"gstyles/styleguide/icons/svgs/hashtag-outline.svg": 66329,
	"gstyles/styleguide/icons/svgs/hashtag-solid.svg": 19056,
	"gstyles/styleguide/icons/svgs/heart-outline.svg": 85330,
	"gstyles/styleguide/icons/svgs/heart-solid.svg": 54146,
	"gstyles/styleguide/icons/svgs/home-outline.svg": 11137,
	"gstyles/styleguide/icons/svgs/home-solid.svg": 24970,
	"gstyles/styleguide/icons/svgs/icon-currency-dollar-solid.svg": 80437,
	"gstyles/styleguide/icons/svgs/icon-user-remove-outline.svg": 65766,
	"gstyles/styleguide/icons/svgs/identification-outline.svg": 88757,
	"gstyles/styleguide/icons/svgs/identification-solid.svg": 68124,
	"gstyles/styleguide/icons/svgs/inbox-in-outline.svg": 32677,
	"gstyles/styleguide/icons/svgs/inbox-in-solid.svg": 66722,
	"gstyles/styleguide/icons/svgs/inbox-outline.svg": 76392,
	"gstyles/styleguide/icons/svgs/inbox-solid.svg": 66911,
	"gstyles/styleguide/icons/svgs/information-circle-outline.svg": 66515,
	"gstyles/styleguide/icons/svgs/information-circle-solid.svg": 22203,
	"gstyles/styleguide/icons/svgs/key-outline.svg": 97010,
	"gstyles/styleguide/icons/svgs/key-solid.svg": 81926,
	"gstyles/styleguide/icons/svgs/library-outline.svg": 67892,
	"gstyles/styleguide/icons/svgs/light-bulb-outline.svg": 95212,
	"gstyles/styleguide/icons/svgs/light-bulb-solid.svg": 79690,
	"gstyles/styleguide/icons/svgs/lightning-bolt-outline.svg": 68015,
	"gstyles/styleguide/icons/svgs/lightning-bolt-solid.svg": 41851,
	"gstyles/styleguide/icons/svgs/link-outline.svg": 84641,
	"gstyles/styleguide/icons/svgs/link-solid.svg": 42643,
	"gstyles/styleguide/icons/svgs/location-marker-outline.svg": 65759,
	"gstyles/styleguide/icons/svgs/location-marker-solid.svg": 48702,
	"gstyles/styleguide/icons/svgs/lock-closed-outline.svg": 37405,
	"gstyles/styleguide/icons/svgs/lock-closed-solid.svg": 66024,
	"gstyles/styleguide/icons/svgs/lock-open-outline.svg": 45159,
	"gstyles/styleguide/icons/svgs/lock-open-solid.svg": 22809,
	"gstyles/styleguide/icons/svgs/logout-outline-1.svg": 57684,
	"gstyles/styleguide/icons/svgs/logout-outline.svg": 63840,
	"gstyles/styleguide/icons/svgs/logout-solid-1.svg": 32185,
	"gstyles/styleguide/icons/svgs/logout-solid.svg": 79433,
	"gstyles/styleguide/icons/svgs/mail-open-outline.svg": 2329,
	"gstyles/styleguide/icons/svgs/mail-open-solid.svg": 60082,
	"gstyles/styleguide/icons/svgs/mail-outline.svg": 52173,
	"gstyles/styleguide/icons/svgs/mail-solid-1.svg": 49826,
	"gstyles/styleguide/icons/svgs/mail-solid.svg": 6869,
	"gstyles/styleguide/icons/svgs/map-outline.svg": 87617,
	"gstyles/styleguide/icons/svgs/map-solid.svg": 79080,
	"gstyles/styleguide/icons/svgs/md-library-solid.svg": 39077,
	"gstyles/styleguide/icons/svgs/menu-alt-1-outline.svg": 71380,
	"gstyles/styleguide/icons/svgs/menu-alt-1-solid.svg": 25029,
	"gstyles/styleguide/icons/svgs/menu-alt-2-outline.svg": 98309,
	"gstyles/styleguide/icons/svgs/menu-alt-2-solid.svg": 27160,
	"gstyles/styleguide/icons/svgs/menu-alt-3-outline.svg": 81050,
	"gstyles/styleguide/icons/svgs/menu-alt-3-solid.svg": 92723,
	"gstyles/styleguide/icons/svgs/menu-alt-4-outline.svg": 78588,
	"gstyles/styleguide/icons/svgs/menu-alt-4-solid.svg": 47119,
	"gstyles/styleguide/icons/svgs/menu-outline.svg": 14703,
	"gstyles/styleguide/icons/svgs/menu-solid.svg": 77089,
	"gstyles/styleguide/icons/svgs/microphone-outline.svg": 51319,
	"gstyles/styleguide/icons/svgs/microphone-solid.svg": 84228,
	"gstyles/styleguide/icons/svgs/minimal-summary.svg": 20756,
	"gstyles/styleguide/icons/svgs/minus-circle-outline.svg": 62068,
	"gstyles/styleguide/icons/svgs/minus-circle-solid.svg": 70081,
	"gstyles/styleguide/icons/svgs/minus-outline-1.svg": 32740,
	"gstyles/styleguide/icons/svgs/minus-outline.svg": 75840,
	"gstyles/styleguide/icons/svgs/minus-solid-1.svg": 4183,
	"gstyles/styleguide/icons/svgs/minus-solid.svg": 30517,
	"gstyles/styleguide/icons/svgs/moon-outline.svg": 11452,
	"gstyles/styleguide/icons/svgs/moon-solid.svg": 18595,
	"gstyles/styleguide/icons/svgs/music-note-outline.svg": 56398,
	"gstyles/styleguide/icons/svgs/music-note-solid.svg": 94244,
	"gstyles/styleguide/icons/svgs/newspaper-outline.svg": 9196,
	"gstyles/styleguide/icons/svgs/newspaper-solid.svg": 52361,
	"gstyles/styleguide/icons/svgs/office-building-outline.svg": 11751,
	"gstyles/styleguide/icons/svgs/office-building-solid.svg": 64623,
	"gstyles/styleguide/icons/svgs/paper-airplane-outline.svg": 83735,
	"gstyles/styleguide/icons/svgs/paper-airplane-solid.svg": 99649,
	"gstyles/styleguide/icons/svgs/paper-clip-outline.svg": 31281,
	"gstyles/styleguide/icons/svgs/paper-clip-solid.svg": 59902,
	"gstyles/styleguide/icons/svgs/pause-outline.svg": 33906,
	"gstyles/styleguide/icons/svgs/pause-solid.svg": 76582,
	"gstyles/styleguide/icons/svgs/pencil-alt-outline.svg": 28913,
	"gstyles/styleguide/icons/svgs/pencil-alt-solid.svg": 54638,
	"gstyles/styleguide/icons/svgs/pencil-outline.svg": 10223,
	"gstyles/styleguide/icons/svgs/pencil-solid.svg": 67753,
	"gstyles/styleguide/icons/svgs/phone-incoming-outline.svg": 10225,
	"gstyles/styleguide/icons/svgs/phone-incoming-solid.svg": 25095,
	"gstyles/styleguide/icons/svgs/phone-missed-call-outline.svg": 60895,
	"gstyles/styleguide/icons/svgs/phone-missed-call-solid.svg": 62082,
	"gstyles/styleguide/icons/svgs/phone-outgoing-outline.svg": 39718,
	"gstyles/styleguide/icons/svgs/phone-outgoing-solid.svg": 40837,
	"gstyles/styleguide/icons/svgs/phone-outline.svg": 53113,
	"gstyles/styleguide/icons/svgs/phone-solid.svg": 43062,
	"gstyles/styleguide/icons/svgs/photograph-outline.svg": 40628,
	"gstyles/styleguide/icons/svgs/photograph-solid.svg": 3104,
	"gstyles/styleguide/icons/svgs/play-outline-1.svg": 14094,
	"gstyles/styleguide/icons/svgs/play-outline.svg": 3813,
	"gstyles/styleguide/icons/svgs/play-solid.svg": 95328,
	"gstyles/styleguide/icons/svgs/plus-circle-outline.svg": 28330,
	"gstyles/styleguide/icons/svgs/plus-circle-solid.svg": 32394,
	"gstyles/styleguide/icons/svgs/plus-outline-1.svg": 87146,
	"gstyles/styleguide/icons/svgs/plus-outline.svg": 11922,
	"gstyles/styleguide/icons/svgs/plus-solid-1.svg": 67379,
	"gstyles/styleguide/icons/svgs/plus-solid.svg": 68264,
	"gstyles/styleguide/icons/svgs/presentation-chart-bar-outline.svg": 60995,
	"gstyles/styleguide/icons/svgs/presentation-chart-bar-solid.svg": 61336,
	"gstyles/styleguide/icons/svgs/presentation-chart-line-outline.svg": 35934,
	"gstyles/styleguide/icons/svgs/presentation-chart-line-solid.svg": 28237,
	"gstyles/styleguide/icons/svgs/printer-outline.svg": 68285,
	"gstyles/styleguide/icons/svgs/printer-solid.svg": 64042,
	"gstyles/styleguide/icons/svgs/puzzle-outline.svg": 76384,
	"gstyles/styleguide/icons/svgs/puzzle-solid.svg": 1148,
	"gstyles/styleguide/icons/svgs/qrcode-outline.svg": 73799,
	"gstyles/styleguide/icons/svgs/qrcode-solid.svg": 77086,
	"gstyles/styleguide/icons/svgs/question-mark-circle-outline.svg": 82117,
	"gstyles/styleguide/icons/svgs/question-mark-circle-solid.svg": 92516,
	"gstyles/styleguide/icons/svgs/receipt-refund-outline.svg": 21856,
	"gstyles/styleguide/icons/svgs/receipt-refund-solid.svg": 27847,
	"gstyles/styleguide/icons/svgs/receipt-tax-outline.svg": 49426,
	"gstyles/styleguide/icons/svgs/receipt-tax-solid.svg": 16746,
	"gstyles/styleguide/icons/svgs/refresh-outline.svg": 530,
	"gstyles/styleguide/icons/svgs/refresh-solid.svg": 22113,
	"gstyles/styleguide/icons/svgs/reply-outline.svg": 14325,
	"gstyles/styleguide/icons/svgs/reply-solid.svg": 40734,
	"gstyles/styleguide/icons/svgs/rewind-outline.svg": 34093,
	"gstyles/styleguide/icons/svgs/rewind-solid.svg": 43741,
	"gstyles/styleguide/icons/svgs/rss-outline.svg": 40784,
	"gstyles/styleguide/icons/svgs/rss-solid.svg": 21399,
	"gstyles/styleguide/icons/svgs/save-as-outline.svg": 4201,
	"gstyles/styleguide/icons/svgs/save-as-solid.svg": 49414,
	"gstyles/styleguide/icons/svgs/save-outline.svg": 3117,
	"gstyles/styleguide/icons/svgs/save-solid.svg": 29786,
	"gstyles/styleguide/icons/svgs/scale-outline.svg": 58521,
	"gstyles/styleguide/icons/svgs/scale-solid.svg": 71465,
	"gstyles/styleguide/icons/svgs/scissors-outline.svg": 41896,
	"gstyles/styleguide/icons/svgs/scissors-solid.svg": 70078,
	"gstyles/styleguide/icons/svgs/search-circle-outline.svg": 20357,
	"gstyles/styleguide/icons/svgs/search-circle-solid.svg": 51608,
	"gstyles/styleguide/icons/svgs/search-outline.svg": 63193,
	"gstyles/styleguide/icons/svgs/search-solid.svg": 60220,
	"gstyles/styleguide/icons/svgs/selector-outline.svg": 78483,
	"gstyles/styleguide/icons/svgs/selector-solid.svg": 7797,
	"gstyles/styleguide/icons/svgs/server-outline.svg": 38830,
	"gstyles/styleguide/icons/svgs/server-solid.svg": 51171,
	"gstyles/styleguide/icons/svgs/share-outline.svg": 53160,
	"gstyles/styleguide/icons/svgs/share-solid.svg": 83592,
	"gstyles/styleguide/icons/svgs/shield-check-outline.svg": 58660,
	"gstyles/styleguide/icons/svgs/shield-check-solid.svg": 41842,
	"gstyles/styleguide/icons/svgs/shield-exclamation-outline.svg": 78335,
	"gstyles/styleguide/icons/svgs/shield-exclamation-solid.svg": 66108,
	"gstyles/styleguide/icons/svgs/shoes-category-outline.svg": 11823,
	"gstyles/styleguide/icons/svgs/shopping-bag-outline.svg": 29782,
	"gstyles/styleguide/icons/svgs/shopping-bag-solid.svg": 32744,
	"gstyles/styleguide/icons/svgs/shopping-cart-outline.svg": 34838,
	"gstyles/styleguide/icons/svgs/sm-view-grid-add-outline.svg": 86348,
	"gstyles/styleguide/icons/svgs/sort-ascending-outline.svg": 852,
	"gstyles/styleguide/icons/svgs/sort-ascending-solid.svg": 806,
	"gstyles/styleguide/icons/svgs/sort-descending-outline.svg": 14193,
	"gstyles/styleguide/icons/svgs/sort-descending-solid.svg": 45894,
	"gstyles/styleguide/icons/svgs/sparkles-outline.svg": 23945,
	"gstyles/styleguide/icons/svgs/sparkles-solid.svg": 74843,
	"gstyles/styleguide/icons/svgs/speakerphone-outline.svg": 33402,
	"gstyles/styleguide/icons/svgs/speakerphone-solid.svg": 40,
	"gstyles/styleguide/icons/svgs/star-outline.svg": 76001,
	"gstyles/styleguide/icons/svgs/star-solid.svg": 95374,
	"gstyles/styleguide/icons/svgs/status-offline-outline.svg": 43745,
	"gstyles/styleguide/icons/svgs/status-offline-solid.svg": 22132,
	"gstyles/styleguide/icons/svgs/status-online-outline.svg": 54975,
	"gstyles/styleguide/icons/svgs/status-online-solid.svg": 25073,
	"gstyles/styleguide/icons/svgs/stop-outline.svg": 52311,
	"gstyles/styleguide/icons/svgs/stop-solid.svg": 27538,
	"gstyles/styleguide/icons/svgs/subtitles.svg": 24247,
	"gstyles/styleguide/icons/svgs/summary.svg": 55608,
	"gstyles/styleguide/icons/svgs/sun-outline.svg": 66766,
	"gstyles/styleguide/icons/svgs/sun-solid.svg": 88463,
	"gstyles/styleguide/icons/svgs/support-outline.svg": 65256,
	"gstyles/styleguide/icons/svgs/support-solid.svg": 98678,
	"gstyles/styleguide/icons/svgs/switch-horizontal-outline.svg": 13584,
	"gstyles/styleguide/icons/svgs/switch-horizontal-solid.svg": 40392,
	"gstyles/styleguide/icons/svgs/switch-vertical-outline.svg": 16786,
	"gstyles/styleguide/icons/svgs/switch-vertical-solid.svg": 4897,
	"gstyles/styleguide/icons/svgs/table-outline.svg": 22939,
	"gstyles/styleguide/icons/svgs/table-solid-1.svg": 85424,
	"gstyles/styleguide/icons/svgs/table-solid.svg": 60113,
	"gstyles/styleguide/icons/svgs/tag-outline.svg": 11178,
	"gstyles/styleguide/icons/svgs/tag-solid.svg": 2973,
	"gstyles/styleguide/icons/svgs/template-outline.svg": 43774,
	"gstyles/styleguide/icons/svgs/template-solid.svg": 14676,
	"gstyles/styleguide/icons/svgs/terminal-outline.svg": 35730,
	"gstyles/styleguide/icons/svgs/terminal-solid.svg": 27917,
	"gstyles/styleguide/icons/svgs/thumb-down-outline.svg": 51107,
	"gstyles/styleguide/icons/svgs/thumb-down-solid.svg": 83292,
	"gstyles/styleguide/icons/svgs/thumb-up-outline.svg": 84344,
	"gstyles/styleguide/icons/svgs/thumb-up-solid.svg": 5293,
	"gstyles/styleguide/icons/svgs/ticket-outline.svg": 45418,
	"gstyles/styleguide/icons/svgs/ticket-solid.svg": 4616,
	"gstyles/styleguide/icons/svgs/translate-outline.svg": 19891,
	"gstyles/styleguide/icons/svgs/translate-solid.svg": 59787,
	"gstyles/styleguide/icons/svgs/trash-outline.svg": 34208,
	"gstyles/styleguide/icons/svgs/trash-solid.svg": 96126,
	"gstyles/styleguide/icons/svgs/trending-down-outline.svg": 13279,
	"gstyles/styleguide/icons/svgs/trending-down-solid.svg": 30143,
	"gstyles/styleguide/icons/svgs/trending-up-outline.svg": 19076,
	"gstyles/styleguide/icons/svgs/trending-up-solid.svg": 92462,
	"gstyles/styleguide/icons/svgs/truck-outline.svg": 18512,
	"gstyles/styleguide/icons/svgs/truck-solid.svg": 89892,
	"gstyles/styleguide/icons/svgs/upload-outline.svg": 97439,
	"gstyles/styleguide/icons/svgs/upload-solid.svg": 78289,
	"gstyles/styleguide/icons/svgs/user-add-outline.svg": 97862,
	"gstyles/styleguide/icons/svgs/user-add-solid.svg": 50685,
	"gstyles/styleguide/icons/svgs/user-circle-outline.svg": 70959,
	"gstyles/styleguide/icons/svgs/user-circle-solid.svg": 26497,
	"gstyles/styleguide/icons/svgs/user-group-outline.svg": 72757,
	"gstyles/styleguide/icons/svgs/user-group-solid.svg": 28980,
	"gstyles/styleguide/icons/svgs/user-outline.svg": 86006,
	"gstyles/styleguide/icons/svgs/user-remove-solid.svg": 53475,
	"gstyles/styleguide/icons/svgs/user-solid.svg": 81718,
	"gstyles/styleguide/icons/svgs/users-outline.svg": 39661,
	"gstyles/styleguide/icons/svgs/users-solid.svg": 7366,
	"gstyles/styleguide/icons/svgs/variable-outline.svg": 26169,
	"gstyles/styleguide/icons/svgs/variable-solid.svg": 62170,
	"gstyles/styleguide/icons/svgs/video-camera-outline.svg": 26339,
	"gstyles/styleguide/icons/svgs/video-camera-solid.svg": 79344,
	"gstyles/styleguide/icons/svgs/view-boards-outline.svg": 46083,
	"gstyles/styleguide/icons/svgs/view-boards-solid.svg": 18698,
	"gstyles/styleguide/icons/svgs/view-grid-add-solid.svg": 86270,
	"gstyles/styleguide/icons/svgs/view-grid-outline.svg": 20035,
	"gstyles/styleguide/icons/svgs/view-grid-solid.svg": 9145,
	"gstyles/styleguide/icons/svgs/view-list-outline.svg": 57319,
	"gstyles/styleguide/icons/svgs/view-list-solid.svg": 73504,
	"gstyles/styleguide/icons/svgs/volume-off-outline.svg": 66982,
	"gstyles/styleguide/icons/svgs/volume-off-solid.svg": 77363,
	"gstyles/styleguide/icons/svgs/volume-up-outline.svg": 50730,
	"gstyles/styleguide/icons/svgs/volume-up-solid.svg": 11577,
	"gstyles/styleguide/icons/svgs/wifi-outline.svg": 96503,
	"gstyles/styleguide/icons/svgs/wifi-solid.svg": 99039,
	"gstyles/styleguide/icons/svgs/x-circle-outline.svg": 77768,
	"gstyles/styleguide/icons/svgs/x-circle-solid.svg": 91814,
	"gstyles/styleguide/icons/svgs/x-outline.svg": 39548,
	"gstyles/styleguide/icons/svgs/x-solid-white.svg": 84759,
	"gstyles/styleguide/icons/svgs/x-solid.svg": 78019,
	"gstyles/styleguide/icons/svgs/zoom-in-outline.svg": 10702,
	"gstyles/styleguide/icons/svgs/zoom-in-solid.svg": 80810,
	"gstyles/styleguide/icons/svgs/zoom-out-outline.svg": 62224,
	"gstyles/styleguide/icons/svgs/zoom-out-solid.svg": 21791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15459;